"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const inputValueApplyTextMask = ({ inputValue, mask, }) => {
    if (!mask) {
        return inputValue;
    }
    let masked = '';
    let inputIndex = 0;
    mask.split('').forEach((maskChar) => {
        const inputValueChar = inputValue.at(inputIndex);
        if (!inputValueChar) {
            return;
        }
        switch (maskChar) {
            case '9':
                inputIndex += 1;
                if (inputValueChar.match(/\d/)) {
                    masked += inputValueChar;
                }
                break;
            case 'A':
                inputIndex += 1;
                if (inputValueChar.match(/[a-zA-Z]/)) {
                    masked += inputValueChar;
                }
                break;
            case 'S':
                inputIndex += 1;
                if (inputValueChar.match(/[a-z0-9]/i)) {
                    masked += inputValueChar;
                }
                break;
            default: {
                if (maskChar === inputValueChar) {
                    inputIndex += 1;
                }
                masked += maskChar;
                break;
            }
        }
    });
    return masked;
};
exports.default = inputValueApplyTextMask;
